<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px">
      <div class="modal-header">
        <div class="title">编辑服务</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">

        <el-row>
          <el-col :span="24" class="item">
            <el-col :span="6" class="item">
              <div>预约时间</div>
              <el-date-picker disabled
                  v-model="planTime"
                  type="datetime"
                  style="width:100%;"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择预约时间">
              </el-date-picker>
            </el-col>
            <el-col :span="6" class="item">
              <div>开始时间</div>
              <el-date-picker @change="startTimeChange"
                  v-model="startTime"
                  type="datetime"
                  style="width:100%;"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择预约时间">
              </el-date-picker>
            </el-col>
            <el-col :span="6" class="item">
              <div>结束时间</div>
              <el-date-picker @change="endTimeChange"
                  v-model="endTime"
                  type="datetime"
                  style="width:100%;"
                  value-format="yyyy-MM-dd HH:mm"
                  placeholder="选择预约时间">
              </el-date-picker>
            </el-col>
            <el-col :span="6" class="item">
              <div>服务时长</div>
              <el-input v-model="spanTime" disabled style="width: 100%"></el-input>
            </el-col>
          </el-col>
        </el-row>

        <div style="height: 20px;"></div>

        <el-row>
          <el-col :span="24" class="item">
            <el-col :span="8" class="item">
              <div>开始服务备注</div>
              <el-input type="textarea" v-model="remarkStart" :rows="6"/>
            </el-col>
            <el-col :span="16" class="item">
              <div>开始服务拍照</div>
              <el-upload
                  action=""
                  :limit="limitCountStart"
                  :before-upload="beforeUploadStart"
                  :on-preview="handlePictureCardPreviewStart"
                  :on-change="handleChangeStart"
                  :on-success="imgSuccessStart"
                  :http-request="uploadHttpStart"
                  list-type="picture-card"
                  :on-remove="handleRemoveStart"
                  :class="{disabled:uploadDisabledStart}"
                  :file-list="fileListStart">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :modal-append-to-body="false" :visible.sync="imgVisibleStart" width="30%">
                <img width="100%" :src="dialogImageUrlStart" alt="图片未找到"/>
              </el-dialog>
            </el-col>
          </el-col>
        </el-row>

        <div style="height: 20px;"></div>

        <el-row>
          <el-col :span="24" class="item">
            <el-col :span="8" class="item">
              <div>结束服务备注</div>
              <el-input type="textarea" v-model="remarkEnd" :rows="6"/>
            </el-col>
            <el-col :span="16" class="item">
              <div>结束服务拍照</div>
              <el-upload
                  action=""
                  :limit="limitCountEnd"
                  :before-upload="beforeUploadEnd"
                  :on-preview="handlePictureCardPreviewEnd"
                  :on-change="handleChangeEnd"
                  :on-success="imgSuccessEnd"
                  :http-request="uploadHttpEnd"
                  list-type="picture-card"
                  :on-remove="handleRemoveEnd"
                  :class="{disabled:uploadDisabledEnd}"
                  :file-list="fileListEnd">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :modal-append-to-body="false" :visible.sync="imgVisibleEnd" width="30%">
                <img width="100%" :src="dialogImageUrlEnd" alt="图片未找到"/>
              </el-dialog>
            </el-col>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm()">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'GetGood',
  data() {
    return {

      loading: false,

      orderBusinessCode:'',
      planTime:'',

      remarkStart:'',
      imgsStart:[],
      remarkEnd:'',
      imgsEnd:[],

      startTime:'',
      endTime:'',

      spanTime:0,




      limitCountStart: 2,
      uploadDisabledStart: false,
      //是否显示预览图片
      imgVisibleStart: false,
      //预览图片url
      dialogImageUrlStart: "",
      fileListStart: [],
      headImgArrStart:[],


      limitCountEnd: 2,
      uploadDisabledEnd: false,
      //是否显示预览图片
      imgVisibleEnd: false,
      //预览图片url
      dialogImageUrlEnd: "",
      fileListEnd: [],
      headImgArrEnd:[],


    }
  },
  components:{

  },
  methods: {
    init(row){

      this.orderBusinessCode = row.orderBusinessCode;
      this.planTime = row.planTime;

      this.startTime = '';
      this.endTime = '';

      this.fileListStart = [];
      this.headImgArrStart = [];
      this.fileListEnd = [];
      this.headImgArrEnd = [];
      this.uploadDisabledStart=false;
      this.uploadDisabledEnd = false;

      this.remarkStart = '';
      this.remarkEnd = '';
      this.spanTime = 0;

      this.imgsStart = [];
      this.imgsEnd = [];

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    startTimeChange(val){
      if(val){
        var st = Date.parse(new Date(timefilters(val)));
        var et = Date.parse(new Date(timefilters(this.endTime)));

        if(et>=st){
          let ss = et-st;
          //console.log(ss/1000/60/60);
          this.spanTime = ss/1000/60/60;
        }

      }
    },
    endTimeChange(val){
      if(val){
        var et = Date.parse(new Date(timefilters(val)));
        var st = Date.parse(new Date(timefilters(this.startTime)));

        if(et>=st){
          let ss = et-st;
          //console.log(ss/1000/60/60);
          this.spanTime = ss/1000/60/60;
        }
      }
    },



    confirm(){

      if(this.startTime =='' || this.startTime == null){
        this.$message.info("请选择开始时间");
        return;
      }
      if(this.endTime =='' || this.endTime == null){
        this.$message.info("请选择结束时间");
        return;
      }

      var et = Date.parse(new Date(timefilters(this.endTime)));
      var st = Date.parse(new Date(timefilters(this.startTime)));
      if(st>=et){
        this.$message.info("结束时间应晚于开始时间");
        return;
      }

      for(let i=0;i<this.headImgArrStart.length;i++){
        this.imgsStart.push(this.headImgArrStart[i].url);
      }
      for(let i=0;i<this.headImgArrEnd.length;i++){
        this.imgsEnd.push(this.headImgArrEnd[i].url);
      }


      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"AppCare/ServeOver",
        data: {
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          timeStr:timeStr,
          staffCode:getStaffCode(),
          orderBusinessCode:this.orderBusinessCode,
          startTime:this.startTime,
          endTime:this.endTime,

          remarkStart:this.remarkStart,
          imgsStart:this.imgsStart,
          remarkEnd:this.remarkEnd,
          imgsEnd:this.imgsEnd,

        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.closeSelf();
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },

    timefilter(row){
      return timefilters(row.planTime).substring(0,16);
    },







    // 图片上传成功 不执行
    imgSuccessStart(response, file, fileList) {
      console.log('imgSuccessStart',response,file,fileList);
      this.uploadDisabledStart = fileList.length >= this.limitCountStart;
    },

    // 预览图片
    handlePictureCardPreviewStart(file) {
      console.log('handlePictureCardPreviewStart',file);
      this.imgVisibleStart = true;
      this.dialogImageUrlStart = file.url;
    },
    // 删除图片
    handleRemoveStart(file, fileList) {
      console.log('handleRemoveStart',fileList);
      this.uploadDisabledStart = fileList.length >= this.limitCountStart;

      let Pics = this.headImgArrStart;
      Pics.forEach((item, index) => {
        if (file.uid == item.uid) {
          Pics.splice(index, 1);
        }
      })

    },

    //图片更改
    handleChangeStart(file,fileList) {
      console.log('handleChangeStart',fileList);
      this.uploadDisabledStart = fileList.length >= this.limitCountStart;
    },

    beforeUploadStart(){
      if(this.startTime == ''){
        this.$message.warning("请选择开始时间");
        this.fileListStart = [];
      }
    },
    uploadHttpStart(file) {
      //console.log('uploadHttpStart',file);

      if(this.startTime == ''){
        return;
      }

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append("time",this.startTime);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;
      that.fileListStart.push({uid:file.file.uid,name:file.file.name,url:''});

      this.$axios.post(this.$shopUrl+'Upload/ImgsWaterStaff',fd).then(function(res){
        //console.log(res);

        if(res.data.error == 0){
          that.headImgArrStart.push({ url: res.data.data.path,uid:file.file.uid  });
          for(let i=0;i<that.fileListStart.length;i++){
            if(that.fileListStart[i].uid == file.file.uid){
              that.fileListStart[i].url = that.$imgUrl+ res.data.data.path+"_watermark.jpg";
            }
          }
        }
        else if(res.data.error == 1){
          let Pics = that.fileListStart;
          Pics.forEach((item, index) => {
            if (file.file.uid == item.uid) {
              Pics.splice(index, 1);
            }
          })
        }

        that.uploadDisabledStart = that.fileListStart.length >= that.limitCountStart;

      }).catch(error => {
        console.log(error);

        let Pics = that.fileListStart;
        Pics.forEach((item, index) => {
          if (file.file.uid == item.uid) {
            Pics.splice(index, 1);
          }
        })

        that.uploadDisabledStart = that.fileListStart.length >= that.limitCountStart;


      })


    },

    //------------------------------

    // 图片上传成功 不执行
    imgSuccessEnd(response, file, fileList) {
      this.uploadDisabledEnd = fileList.length >= this.limitCountEnd;
    },
    // 预览图片
    handlePictureCardPreviewEnd(file) {
      this.imgVisibleEnd = true;
      this.dialogImageUrlEnd = file.url;
    },
    // 删除图片
    handleRemoveEnd(file, fileList) {
      this.uploadDisabledEnd = fileList.length >= this.limitCountEnd;

      let Pics = this.headImgArrEnd;
      Pics.forEach((item, index) => {
        if (file.uid == item.uid) {
          Pics.splice(index, 1);
        }
      })

    },
    //图片更改
    handleChangeEnd(file,fileList) {
      this.fileListEnd.push({uid:file.uid,name:file.name,url:''});
      this.uploadDisabledEnd = fileList.length >= this.limitCountEnd;
    },
    beforeUploadEnd(){
      if(this.endTime == ''){
        this.$message.warning("请选择结束时间");
        this.fileListEnd = [];
      }
    },
    uploadHttpEnd(file) {

      if(this.endTime == ''){
        return;
      }

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append("time",this.endTime);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;
      that.fileListEnd.push({uid:file.file.uid,name:file.file.name,url:''});

      this.$axios.post(this.$shopUrl+'Upload/ImgsWaterStaff',fd).then(function(res){
        //console.log(res.data);

        if(res.data.error == 0){
          that.headImgArrEnd.push({ url: res.data.data.path,uid:file.file.uid  });
          for(let i=0;i<that.fileListEnd.length;i++){
            if(that.fileListEnd[i].uid == file.file.uid){
              that.fileListEnd[i].url = that.$imgUrl+ res.data.data.path+"_watermark.jpg";
            }
          }
        }
        else if(res.data.error == 1){
          let Pics = that.fileListEnd;
          Pics.forEach((item, index) => {
            if (file.file.uid == item.uid) {
              Pics.splice(index, 1);
            }
          })
        }

        that.uploadDisabledEnd = that.fileListEnd.length >= that.limitCountEnd;

      }).catch(error => {
        console.log(error);

        let Pics = that.fileListEnd;
        Pics.forEach((item, index) => {
          if (file.file.uid == item.uid) {
            Pics.splice(index, 1);
          }
        })

        that.uploadDisabledEnd = that.fileListEnd.length >= that.limitCountEnd;

      })


    },




  }
}


</script>

<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>
